/**
 * S01 v3 · «флип-тройка» — three concept cards (`.flip` inside `.flips`) that flip
 * front (`.f`) ↔ back (`.b`) on click/keyboard by toggling `.on`.
 *
 * Ephemeral visual toggle (no persistence) · StrictMode-safe (init-guard + cleanup).
 * Distinct from `.flip-card` (`initFlipCards`): the v3 synthesis mockup
 * (`04_DESIGN/mockup_s01_t00_ms00_ms01_synthesis.html`) uses the `.flip`/`.on` contract.
 */
export function initFlipTriple(root: HTMLElement): () => void {
  const cards = Array.from(root.querySelectorAll<HTMLElement>('.flips > .flip'));
  const cleanups: Array<() => void> = [];

  for (const card of cards) {
    if (card.dataset.flipTripleInit === '1') continue;
    card.dataset.flipTripleInit = '1';
    if (!card.hasAttribute('tabindex')) card.tabIndex = 0;
    if (!card.hasAttribute('role')) card.setAttribute('role', 'button');
    if (!card.hasAttribute('aria-pressed')) card.setAttribute('aria-pressed', 'false');

    const toggle = () => {
      const on = card.classList.toggle('on');
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    };

    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('a, button, input, textarea, select, [data-no-flip]')) return;
      toggle();
    };

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    };

    card.addEventListener('click', onClick);
    card.addEventListener('keydown', onKeyDown);
    cleanups.push(() => {
      card.removeEventListener('click', onClick);
      card.removeEventListener('keydown', onKeyDown);
      delete card.dataset.flipTripleInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
